import { render } from "./ComoChegar.vue?vue&type=template&id=24e86838&scoped=true&lang=pug"
import script from "./ComoChegar.vue?vue&type=script&setup=true&lang=js"
export * from "./ComoChegar.vue?vue&type=script&setup=true&lang=js"

import "./ComoChegar.vue?vue&type=style&index=0&id=24e86838&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e86838"]])

export default __exports__